import Nullstack from 'nullstack';
export default function IconMilkshake({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-milkshake",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M17 10a5 5 0 0 0 -10 0"
  }), "   ", Nullstack.element("rect", {
    x: "6",
    y: "10",
    width: "12",
    height: "3",
    rx: "1"
  }), "   ", Nullstack.element("path", {
    d: "M7 13l1.81 7.243a1 1 0 0 0 .97 .757h4.44a1 1 0 0 0 .97 -.757l1.81 -7.243"
  }), "   ", Nullstack.element("path", {
    d: "M12 5v-2"
  }), " ");
}